import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'header-lora',
    templateUrl: 'header.template.html',
    styleUrls: ['header.style.scss']
})
export class HeaderComponent implements OnInit{
  userName: string;
  userRole: string;
  onFilter: any = false;
  getFilterPanel() {
    this.onFilter = !this.onFilter;
  }

  ngOnInit() {
    this.userName = JSON.parse(sessionStorage.getItem('currentUser')).username;
    this.userRole = JSON.parse(sessionStorage.getItem('currentUser')).role;
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/header/header.component.ts